import hydrate from '../common/hydrate';
import GlobalSectionHeaderNavigation from './components/GlobalSectionHeaderNavigation';
import { root, name } from './manifest.json';
hydrate(GlobalSectionHeaderNavigation, root, name);
if (module.hot) {
    module.hot.accept();
}
